// extracted by mini-css-extract-plugin
export default {"pagination-container":"owNWA","paginationContainer":"owNWA"};